import React from "react";
import CloseArtworkButton from "../../components/buttons/CloseArtworkButton";
import ConnectionButton from "../../components/buttons/ConnectionButton";
import { Artwork } from "../../types";

interface HeaderButtonsProps {
  isInline: boolean;
  onClose: () => void;
  artwork?: Artwork;
}

const HeaderButtons: React.FC<HeaderButtonsProps> = ({
  isInline,
  onClose,
  artwork,
}) => {
  return (
    <div className="sticky top-6 flex justify-between w-full z-30">
      <div className="relative left-2 md:left-8">
        <CloseArtworkButton onClick={onClose} />
      </div>
      {!isInline && artwork && (
        <div className="relative right-2 md:right-8">
          <ConnectionButton uuid={artwork.uuid} />
        </div>
      )}
    </div>
  );
};

export default HeaderButtons;
